import React from 'react'
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material'

export interface AwardType {
  id: number
  code: string
  description: string
}

export const awardTypeOptions = new Map<number, AwardType>([
  [1, { id: 1, code: 'CIV', description: 'Civic Organization' }],
  [2, { id: 2, code: 'EDU', description: 'Educational Institution' }],
  [3, { id: 3, code: 'GOV', description: 'Government Agency' }],
  [4, { id: 4, code: 'MIL', description: 'Military' }],
  [5, { id: 5, code: 'PRO', description: 'Professional Organization' }],
  [6, { id: 6, code: 'PUB', description: 'Publication' }],
  [7, { id: 7, code: 'SER', description: 'Service Organization' }],
  [8, { id: 8, code: 'OTH', description: 'Other' }]
])

export const AwardTypeSelect: React.FC<{ value: AwardType | null, updateAwardType: (awardType: AwardType | null) => void, disabled: boolean }> = ({ value, updateAwardType, disabled }) => {
  const handleChange = (value: string | number): void => {
    const selectedOption = awardTypeOptions.get(value as number)
    updateAwardType(selectedOption ?? null)
  }

  return (
      <FormControl fullWidth variant="outlined">
      <InputLabel id="award-type-select-label">Award Type</InputLabel>
      <Select
        labelId="award-type-select-label"
        label="Award Type"
        value={(value != null) ? value.id : ''}
        onChange={(event) => { handleChange(event.target.value) }}
        disabled={disabled}
        fullWidth
      >
        {Array.from(awardTypeOptions.values()).map((awardType) => (
          <MenuItem key={awardType.id} value={awardType.id}>
            {awardType.description}
          </MenuItem>
        ))}
      </Select>
      </FormControl>
  )
}
